//import node_modules
import React from "react";
import { NextPage } from "next";

//layout
import BlogLayout, { BlogLayoutProps } from "@adjust/website/src/layouts/BlogLayout";

//components
import SizedContainer from "@adjust/website/src/components/SizedContainer";
import Typography from "@adjust/website/src/components/Typography";
import TypographyContainer from "@adjust/website/src/components/TypographyContainer";
import BlogImage from "@adjust/website/src/components/BlogImageComponent";

import image from "@adjust/public/images/3c56793a08f50db858c28b38463eab3ecc1db0e2.png";

const BlogPage: NextPage<BlogLayoutProps> = ({ blog, recommendations }) => {
  return (
    <BlogLayout blog={blog} recommendations={recommendations}>
      <SizedContainer size="sm">
        <TypographyContainer>
          <Typography type="heading-one" textAlign="center">
            Welcome to my new Blog…
          </Typography>
        </TypographyContainer>
        <BlogImage src={image} alt={"Picture of Family on vacation"} objectFit="contain" priority />
        <TypographyContainer>
          <Typography type="paragraph">
            Hello Welcome to my new Travel Blog! If you checked out my “About Me” section then you know my name is Stacy Gray coming to you from Raleigh, NC and this a blog about
            all things travel!
          </Typography>
          <Typography type="paragraph">This blog will be packed with exciting trip ideas, insider tips, and secrets to help save you time in planning, and money.</Typography>
          <Typography type="paragraph">It is my goal to give you helpful and fun information to help you plan your family's next travel escape while sharing mine!</Typography>
        </TypographyContainer>
      </SizedContainer>
    </BlogLayout>
  );
};

export default BlogPage;
